// extracted by mini-css-extract-plugin
module.exports = {"tag_list":"TagList_tag_list_1Gqvw"};